module.exports = __webpack_public_path__ + "media/bootstrap-icons/menu-button-wide-fill-530b5a7c.svg";